<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">
    <mat-tab-group>
        <mat-tab label="Details">
            <form [formGroup]="detailsForm">
                <div class="tab-container">
                    <div class="tab-section">
                        <h2 style="background-color:  rgb(6, 24, 116); color: white; text-align: center; font-size: 14px;" >
                            <i style="font-size: 15px;" class="fa-solid fa-info-circle"></i>&nbsp;Shipment Details
                        </h2>
                        <div class="tab-grid-template">
                            <mat-form-field>
                                <mat-label>Date</mat-label>
                                <input matInput formControlName="date">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>ASN Number</mat-label>
                                <input matInput formControlName="asn_number">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Trip Number</mat-label>
                                <input matInput formControlName="trip_number">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>Default Carrier</mat-label>
                                <input matInput formControlName="contact_organization">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Bill Of Lading</mat-label>
                                <input matInput formControlName="external_bill_of_lading">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Total Cartons</mat-label>
                                <input matInput formControlName="total_cartons">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Reported Weight</mat-label>
                                <input matInput formControlName="reported_weight">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Status</mat-label>
                                <input matInput formControlName="status">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Week Number</mat-label>
                                <input matInput formControlName="week_no">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Manifest ID</mat-label>
                                <input matInput formControlName="manifest_id">
                            </mat-form-field>
                        </div>
                        <div class="tab-grid-template">
                            <div style="align-items: center; justify-content: center;">
                                <button mat-raised-button color="primary" (click)="viewShipmentDetails()" style="background-color: rgb(6, 24, 116);">
                                    <i style="font-size: 15px;"  class="fas fa-info-circle"></i>&nbsp;View Shipment Details
                                </button><br><br>
                                <button  *ngIf="shipment_details.status !== 'Work Order Created'" mat-raised-button color="primary" (click)="editShipmentDetails()" style="background-color:rgb(6, 24, 116);">
                                    <i style="font-size: 15px;"  class="fas fa-edit"></i>&nbsp;Edit Shipment Details
                                </button><br><br>
                                <button  *ngIf="shipment_details.status !== 'Work Order Created'" mat-raised-button color="primary" (click)="createWorkOrder()" style="background-color:rgb(240, 8, 8);">
                                    <i style="font-size: 15px;"  class="fas fa-plus-square"></i>&nbsp;Create Work Order
                                </button>
                                <button  *ngIf="shipment_details.status == 'Work Order Created'" mat-raised-button color="primary" (click)="updateBarcode()" style="background-color:rgb(240, 8, 8);">
                                    <i style="font-size: 15px;"  class="fas fa-barcode"></i>&nbsp;Update Work Order Barcodes/Pallets
                                </button>                                
                            </div>                            
                        </div>
                    </div>
                    <div class="tab-section" *ngIf="shipment_details.status == 'Work Order Created'">
                        <h2 style="background-color: rgb(6, 24, 116); color: white; text-align: center; font-size: 14px;" >
                            <i style="font-size: 15px;" class="fa-solid fa-print"></i>&nbsp;Print Document
                        </h2>                        
                        <div *ngFor="let item of shipment.lading" class="each-item">
                            <span style="margin-left: 30px;"><b>Work Order Number:</b></span>&nbsp;&nbsp;
                            <a [href]="'work_order_details/' + item.lading_uuid">{{item.alternate_reference}}</a>&nbsp;&nbsp;
                            <span style="margin-left: 30px;"><b>Shipper: </b>{{item.shipper_name}}</span>&nbsp;&nbsp;
                            <span style="margin-left: 30px;"><b>Consignee: </b>{{item.consignee_name}}</span><br><br>
                            <div style="align-items: center; justify-content: center;">
                                <button mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="printBOL(item.lading_uuid, item.alternate_reference, item.shipper_contact_uuid)">
                                    <i style="font-size: 15px;"  class="fas fa-print"></i>&nbsp;Print Bill Of Lading
                                </button>&nbsp;&nbsp;
                                <button mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="printLabel('packing', item.lading_uuid)">
                                    <i style="font-size: 15px;"  class="fas fa-truck"></i>&nbsp;Print Packing Label
                                </button>&nbsp;&nbsp;
                                <button mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="printLabel('pallet', item.lading_uuid)">
                                    <i style="font-size: 15px;"  class="fas fa-pallet"></i>&nbsp;Print Pallet Label
                                </button>&nbsp;&nbsp;
                                <button mat-raised-button color="primary"  style="background-color:rgb(6, 24, 116);" (click)="printLabel('trailer', item.lading_uuid)">
                                    <i style="font-size: 15px;"  class="fas fa-trailer"></i>&nbsp;Print Trailer Label
                                </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <button mat-raised-button color="primary"  style="background-color:rgb(7, 92, 39);" (click)="createEDIFile(item.lading_uuid, item.alternate_reference)">
                                    <i style="font-size: 15px;"  class="fas fa-file"></i>&nbsp;Create EDI FILE
                                </button><br><br>
                            </div>
                        </div>
                    </div>                        
                    <div class="tab-section">
                        <h2 style="background-color: rgb(6, 24, 116); color: white; text-align: center; font-size: 14px;" >
                            <i style="font-size: 15px;" class="fa-solid fa-clock"></i>&nbsp;Store Hours
                        </h2>
                        <div class="tab-grid-store-hours">
                            <mat-form-field>
                                <mat-label>Appointment Day</mat-label>
                                <input matInput formControlName="appointment_day">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Appointment Start</mat-label>
                                <input matInput type="time" formControlName="appointment_start">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Appointment End</mat-label>
                                <input matInput type="time" formControlName="appointment_end">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Store Number</mat-label>
                                <input matInput formControlName="store_number">
                            </mat-form-field>
                            <mat-checkbox formControlName="express_road">
                                Express Road</mat-checkbox>
                            <mat-checkbox formControlName="ab_carbon_fuel_tax">
                                AB Carbon Fuel Tax</mat-checkbox>
                            <mat-checkbox formControlName="bc_carbon_fuel_tax">
                                BC Carbon Fuel Tax</mat-checkbox>
                        </div>
                    </div>         
                </div>
            </form>
        </mat-tab>

        <mat-tab label="Service Rates">
            <button (click)="addServiceRate()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                <i style="font-size: 15px;"  class="fas fa-plus"></i>Add New Service
            </button>
            <ag-grid-angular style="height: 250px; margin:20px" class="ag-theme-alpine"
                [columnDefs]="serviceRatesColumnDefs" [rowData]="services" (cellEditingStopped)="onCellEditingRatesStopped($event)"
                [defaultColDef]="defaultColDef"></ag-grid-angular>
        </mat-tab>
        <mat-tab label="Barcodes">
            <div class="tab-section">
                <button (click)="addBarcode()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                    <i style="font-size: 15px;"  class="fas fa-plus"></i>&nbsp;Add Barcode
                </button>
                <button (click)="changeBarcode()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                    <i style="font-size: 15px;"  class="fas fa-check"></i>&nbsp;Change All Barcode Statuses
                </button>
                <button (click)="moveBarcode()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                    <i style="font-size: 15px;"  class="fas fa-exchange"></i>&nbsp;Move Barcodes
                </button>
                <button  *ngIf="shipment_details.status == 'Work Order Created'" (click)="updateBarcodePallet()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                    <i style="font-size: 15px;"  class="fas fa-edit"></i>&nbsp;Update Work Order Barcodes/Pallets
                </button>
            </div>
            <ag-grid-angular style="height: 270px; margin:20px" class="ag-theme-alpine" [columnDefs]="barcodeColumnDefs"
                [rowData]="barcodes" (cellEditingStopped)="onCellEditingStopped($event)"
                [defaultColDef]="defaultColDef"></ag-grid-angular>
        </mat-tab>
        <mat-tab label="Pallets">
            <div class="tab-section">
                <button (click)="addPallet()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                    <i style="font-size: 15px;"  class="fas fa-plus"></i>&nbsp;Add A Pallet
                </button>            
                <button (click)="addMultiplePallets()" style="margin: 20px; margin-bottom: 0px;" mat-raised-button color="primary">
                    <i style="font-size: 15px;"  class="fas fa-square-plus"></i>&nbsp;Add Multiple Pallets
                </button>            
            </div>            
            <ag-grid-angular style="height: 270px; margin:20px" class="ag-theme-alpine" [columnDefs]="palletsColumnDefs"
                [rowData]="pallets" [defaultColDef]="defaultColDef"></ag-grid-angular>
        </mat-tab>
    </mat-tab-group>
</ng-container>